import { createAction, createAsyncThunk } from '@reduxjs/toolkit'
import {
  deleteRecurringPayment,
  getRecurringPayment,
  getRecurringPayments,
} from '@services'
import { RecurringPayment } from '@interfaces'

export const fetchRecurringPaymentDetail = createAsyncThunk<
  RecurringPayment,
  string
>('fetchRecurringPaymentDetail', (id: string) => getRecurringPayment(id))

export const fetchRecurringPayments = createAsyncThunk<RecurringPayment[]>(
  'getRecurringPayments',
  async () => {
    return getRecurringPayments()
  },
)

export const removeRecurringPayment = createAsyncThunk<void, string>(
  'removeRecurringPayment',
  (id: string) => deleteRecurringPayment(id),
)

export const clearCancelPayment = createAction('clearCancelPayment')

export const clearRecurringPaymentsList = createAction(
  'clearRecurringPaymentsList',
)
